"use client";

import { mutate } from "swr";
import { ContestAPI, ContestBulkActionByIdsRequest } from "@/restapi/contest";

export const useContestBulkActionByIds = () => {
  const submit = async (req: ContestBulkActionByIdsRequest) => {
    try {
      const res = await ContestAPI.bulkActionByIds(req);

      mutate(`contest-bulk-action-${JSON.stringify(req)}`, res, false);

      // 一覧系の再検証: 全ての contest-list key を再検証
      // ※ bulk action は複数の params 組み合わせに影響する可能性があるため、全て再検証する
      mutate((key) => typeof key === "string" && key.startsWith("contest-list?"));

      return res;
    } catch (err) {
      console.error("Failed to submit contest bulk action by ids:", err);
      throw err;
    }
  };

  return { submit };
};